import { Form } from "antd";
import i18n from "i18next";
import type { FC } from "react";

import type { TerminalVersionEntity } from "src/app/features/TerminalVersion/types/TerminalVersionEntity";
import { SelectDynamic, TextInput } from "../../../../../components/Form/formComponents";
import type { SearchFormProps } from "../../../../../components/Form/types/types";
import { siteSelectConfig } from "../../../../../components/SearchForm/FormSearchUtils";
import { SearchForm } from "../../../../../components/SearchForm/SearchForm";

export const TerminalVersionSearchForm: FC<SearchFormProps<TerminalVersionEntity>> = ({ searchCallback }) => {
    return (
        <SearchForm searchCallback={searchCallback}>
            <Form.Item label={i18n.t("terminalVersionSearchForm.terminalId")} name="terminalId">
                <TextInput name="terminalId" />
            </Form.Item>
            <Form.Item label={i18n.t("terminalVersionSearchForm.configurationVersion")} name="configurationVersion">
                <TextInput name="configurationVersion" />
            </Form.Item>
            <Form.Item name="applicationVersion" label={i18n.t("terminalVersionSearchForm.applicationVersion")}>
                <TextInput name="applicationVersion" />
            </Form.Item>
            <Form.Item name="organizationUnitId" label={i18n.t("terminalVersionSearchForm.siteName")}>
                <SelectDynamic
                    name="organizationUnitId"
                    label={i18n.t("terminalVersionSearchForm.siteId")}
                    fieldConfig={siteSelectConfig}
                />
            </Form.Item>
            <Form.Item label={i18n.t("form.serialNumber")} name="serialNumber">
                <TextInput name="serialNumber" />
            </Form.Item>
        </SearchForm>
    );
};
